import { Transaction } from 'types/services/transactions';

export const transformResource = (resource: Transaction) => {
  return {
    key: resource.id,
    ...resource,
    phoneNumber: resource.order ? resource.order.leaveNumber : '',
    obituaryId: resource.order ? resource.order.id : '',
    orderId: resource.order ? resource.order.uuid : '',
    nameSurname: resource.order ? resource.order.nameSurname : '',
    //totalAmount: Number(resource.totalAmount) / 100,
    purchaseTime: resource.purchaseTime
      ?.toLocaleString()
      .slice(8, 10)
      .concat(
        '.',
        resource.createdAt.slice(5, 7),
        '.',
        resource.createdAt.slice(0, 4),
        ' - ',
        resource.createdAt.slice(11, 16),
      ), //DateTime.fromISO(resource.createdAt).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS),
  };
};

export const articleUrl = (article: Transaction) => {
  let url = '';

  return url;
};
export const textTypes = [
  'Preuzeti tekst',
  'Tekst drugog novinara',
  'Agencijski tekst',
  'Autorski tekst',
  'Prevedeni tekst',
  'Promo tekst',
];
